module.exports = __webpack_public_path__ + "static/media/BizTechFrame2.f3ac71b5.png";